module.exports = __webpack_public_path__ + "static/media/clients.68d01e29.png";